var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"temp-text"}},[(_vm.value)?_c('div',{class:_vm.tempColor()},[_vm._v(_vm._s(_vm.value)+"℃")]):_c('div',[_vm._v("-")])])}
var staticRenderFns = []

export { render, staticRenderFns }